"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlashOrder = void 0;
var get_flash_order_1 = require("./get-flash-order");
Object.defineProperty(exports, "getFlashOrder", { enumerable: true, get: function () { return get_flash_order_1.getFlashOrder; } });
